<template>
  <ui-collapse
    data-test="payment-terms-accordion"
    :selected="open"
    :collapse-id="`collapse-payment-terms`"
  >
    <template #ui-collapse-title>
      <translate>Payment terms</translate>
    </template>
    <template #ui-collapse-body>
      <div v-thtml="paymentTerms" />

      <div
        v-if="
          allowOverrideImmediate &&
          hostedFullPayment &&
          paymentAdvanceDays !== -1
        "
      >
        <br />
        <translate tag="strong">
          You can also opt to pay the full amount at the time of your booking,
          or at any point before the due date.
        </translate>
      </div>
    </template>
  </ui-collapse>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class PaymentTerms extends Vue {
  @Prop({ default: false })
  open: boolean

  @Prop({ required: true })
  paymentTerms: string

  @Prop({ required: true })
  allowOverrideImmediate: boolean

  @Prop({ required: true })
  hostedFullPayment: boolean

  @Prop({ required: true })
  paymentAdvanceDays: number
}

export default toNative(PaymentTerms)
</script>
